module.exports = __webpack_public_path__ + "img/shouhui2.c93660a9.png";